export const getActiveWriters = (writers = []) =>
  writers.filter((w) => w.active !== false);

export const getInactiveWriters = (writers = []) =>
  writers.filter((w) => w.active === false);
